import React from 'react';
// import UploadTicketStatement from '../../Payment/UploadTicketStatement';
import UploadTicketStatement from '../../../Payment/UploadTicketStatement';

// const RevenueFilters = ({
//   filters,
//   setFilters,
//   banks,
//   theatreAccounts,
//   selectedBank,
//   setSelectedBank,
//   selectedTheatreAccount,
//   setSelectedTheatreAccount,
//   handleGenerateClick,
//   showBankSelector,
//   handleGenerateFile,
//   handleBankChange,
//   handleTicketTransactionsExtracted
// }) => {

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({ ...prev, [name]: value }));
//   };

//   const clearFilters = () => {
//     setFilters({
//       paymentMode: 'all',
//       transactionStatus: 'all',
//       dateRange: 'all',
//       startDate: '',
//       endDate: ''
//     });
//   };

//   return (
//     <div className="bg-white p-6 rounded-xl shadow mb-6">
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">

//         {/* Date Range Filter */}
//         <div className="md:col-span-2 bg-gray-50 p-4 rounded-lg border border-gray-200">
//           <div className="flex justify-between items-center mb-2">
//             <h3 className="text-sm font-medium text-gray-700">Date Range</h3>
//             <button
//               onClick={clearFilters}
//               className="text-xs text-red-600 hover:text-red-800"
//             >
//               Clear Filters
//             </button>
//           </div>

//           <select
//             name="dateRange"
//             value={filters.dateRange}
//             onChange={handleFilterChange}
//             className="w-full p-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//           >
//             <option value="all">All Time</option>
//             <option value="today">Today</option>
//             <option value="week">Last 7 Days</option>
//             <option value="month">Last 30 Days</option>
//             <option value="custom">Custom Range</option>
//           </select>

//           {filters.dateRange === 'custom' && (
//             <div className="grid grid-cols-2 gap-3 mt-2">
//               <div>
//                 <label className="block text-xs text-gray-500 mb-1">Start Date</label>
//                 <input
//                   type="date"
//                   name="startDate"
//                   value={filters.startDate}
//                   onChange={handleFilterChange}
//                   className="w-full p-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-xs text-gray-500 mb-1">End Date</label>
//                 <input
//                   type="date"
//                   name="endDate"
//                   value={filters.endDate}
//                   onChange={handleFilterChange}
//                   className="w-full p-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                 />
//               </div>
//             </div>
//           )}

//           {/* Generate Bank File Section */}
//           <div className="mt-4">
//             {!showBankSelector ? (
//               <button
//                 className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors"
//                 onClick={handleGenerateClick}
//               >
//                 Generate Bank File
//               </button>
//             ) : (
//               <div className="flex flex-col gap-3 bg-blue-50 p-3 rounded-lg">
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Payout Bank
//                     </label>
//                     <select
//                       value={selectedBank}
//                       onChange={handleBankChange}
//                       className="w-full p-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                     >
//                       <option value="Select Bank">Select Bank</option>
//                       {banks.map((bank) => (
//                         <option key={bank.id || bank.bankName} value={bank.bankName}>
//                           {bank.bankName}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Beneficiary Account
//                     </label>
//                     <select
//                       value={selectedTheatreAccount?._id || ''}
//                       onChange={(e) => {
//                         const account = theatreAccounts.find(acc => acc._id === e.target.value);
//                         setSelectedTheatreAccount(account || null);
//                       }}
//                       className="w-full p-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                     >
//                       <option value="">Select Beneficiary</option>
//                       {theatreAccounts.map((account) => (
//                         <option key={account._id} value={account._id}>
//                           {account.theatreName} ({account.bankName})
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>
//                 <button
//                   className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors"
//                   onClick={handleGenerateFile}
//                   disabled={!selectedBank || selectedBank === "Select Bank"}
//                 >
//                   Generate File
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Payment Mode Filter */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">Payment Mode</label>
//           <select
//             name="paymentMode"
//             value={filters.paymentMode}
//             onChange={handleFilterChange}
//             className="w-full p-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//           >
//             <option value="all">All Payment Modes</option>
//             {/* You can dynamically generate these options from your data in the parent */}
//           </select>
//         </div>

//         {/* Transaction Status Filter */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
//           <select
//             name="transactionStatus"
//             value={filters.transactionStatus}
//             onChange={handleFilterChange}
//             className="w-full p-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//           >
//             <option value="all">All Statuses</option>
//             {/* You can dynamically generate these options from your data in the parent */}
//           </select>
//         </div>

//         {/* Upload Statement */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">Upload Statement</label>
//           <UploadTicketStatement onTransactionsExtracted={handleTicketTransactionsExtracted} />
//         </div>
//       </div>
//     </div>
//   );
// };




// const RevenueFilters = ({
//   filters,
//   setFilters,
//   banks,
//   theatreAccounts,
//   selectedBank,
//   setSelectedBank,
//   selectedTheatreAccount,
//   setSelectedTheatreAccount,
//   handleGenerateClick,
//   showBankSelector,
//   handleGenerateFile,
//   handleBankChange,
//   handleTicketTransactionsExtracted,
//   theatreOptions, // <-- Add this
//   paymentModeOptions, // <-- Add this
//   transactionStatusOptions, // <-- Add this
// }) => {


//   console.log('filters in the Reenuw filters', filters);

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({ ...prev, [name]: value }));
//   };

//   const clearFilters = () => {
//     setFilters({
//       paymentMode: 'all',
//       transactionStatus: 'all',
//       dateRange: 'all',
//       startDate: '',
//       endDate: ''
//     });
//   };

//   return (
//     <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 mb-6">
//       <h2 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
//         <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
//           <path fillRule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clipRule="evenodd" />
//         </svg>
//         Filters
//       </h2>

//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">

//         {/* Date Range Filter - Expanded Column */}
//         <div className="md:col-span-2 bg-gray-50 p-4 rounded-lg border border-gray-200">
//           <div className="flex justify-between items-center mb-3">
//             <h3 className="text-sm font-medium text-gray-700 flex items-center gap-2">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
//               </svg>
//               Date Range
//             </h3>
//             <button
//               onClick={clearFilters}
//               className="text-xs text-red-600 hover:text-red-800 flex items-center gap-1 transition-colors"
//             >
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
//               </svg>
//               Clear Filters
//             </button>
//           </div>

//           <div className="space-y-3">
//             <select
//               name="dateRange"
//               value={filters.dateRange}
//               onChange={handleFilterChange}
//               className="w-full p-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 shadow-xs"
//             >
//               <option value="all">All Time</option>
//               <option value="today">Today</option>
//               <option value="week">Last 7 Days</option>
//               <option value="month">Last 30 Days</option>
//               <option value="custom">Custom Range</option>
//             </select>

//             {filters.dateRange === 'custom' && (
//               <div className="grid grid-cols-2 gap-3">
//                 <div>
//                   <label className="block text-xs text-gray-500 mb-1">Start Date</label>
//                   <input
//                     type="date"
//                     name="startDate"
//                     value={filters.startDate}
//                     onChange={handleFilterChange}
//                     className="w-full p-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-xs text-gray-500 mb-1">End Date</label>
//                   <input
//                     type="date"
//                     name="endDate"
//                     value={filters.endDate}
//                     onChange={handleFilterChange}
//                     className="w-full p-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                   />
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* Generate Bank File Section */}
//           <div className="mt-4 space-y-3">
//             {!showBankSelector ? (
//               <button
//                 className="w-full px-4 py-2.5 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors flex items-center justify-center gap-2 shadow-sm"
//                 onClick={handleGenerateClick}
//               >
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//                 </svg>
//                 Generate Bank File
//               </button>
//             ) : (
//               <div className="flex flex-col gap-3 bg-blue-50 p-3 rounded-lg border border-blue-100">
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//                   <div>
//                     <label className="block text-xs font-medium text-gray-700 mb-1 flex items-center gap-1">
//                       <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
//                       </svg>
//                       Payout Bank
//                     </label>
//                     <select
//                       value={selectedBank}
//                       onChange={handleBankChange}
//                       className="w-full p-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                     >
//                       <option value="Select Bank">Select Bank</option>
//                       {banks.map((bank) => (
//                         <option key={bank.id || bank.bankName} value={bank.bankName}>
//                           {bank.bankName}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <div>
//                     <label className="block text-xs font-medium text-gray-700 mb-1 flex items-center gap-1">
//                       <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
//                       </svg>
//                       Beneficiary Account
//                     </label>
//                     <select
//                       value={selectedTheatreAccount?._id || ''}
//                       onChange={(e) => {
//                         const account = theatreAccounts.find(acc => acc._id === e.target.value);
//                         setSelectedTheatreAccount(account || null);
//                       }}
//                       className="w-full p-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                     >
//                       <option value="">Select Beneficiary</option>
//                       {theatreAccounts.map((account) => (
//                         <option key={account._id} value={account._id}>
//                           {account.theatreName} ({account.bankName})
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>
//                 <button
//                   className="px-4 py-2.5 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors flex items-center justify-center gap-2 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
//                   onClick={handleGenerateFile}
//                   disabled={!selectedBank || selectedBank === "Select Bank"}
//                 >
//                   <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
//                   </svg>
//                   Generate File
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Payment Mode Filter */}
//         <div className="space-y-1">
//           <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center gap-2">
//             <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
//               <path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
//             </svg>
//             Payment Mode
//           </label>
//           <select
//             name="paymentMode"
//             value={filters.paymentMode}
//             onChange={handleFilterChange}
//             className="w-full p-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 shadow-xs"
//           >
//             <option value="all">All Payment Modes</option>
//             {paymentModeOptions.map((option) => (
//               <option key={option.value} value={option.value}>
//                 {option.label}
//               </option>
//             ))}
//           </select>

//         </div>


//         {/* Theater Filter */}
//         <div className="space-y-1">
//           <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center gap-2">
//             <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
//               <path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
//             </svg>
//             Theatres
//           </label>
//           <select
//             name="theatreName"
//             value={filters.theatreName}
//             onChange={handleFilterChange}
//             className="w-full p-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 shadow-xs"
//           >
//             <option value="all">All Theatres</option>
//             {theatreOptions.map((option) => (
//               <option key={option.value} value={option.value}>
//                 {option.label}
//               </option>
//             ))}
//           </select>

//         </div>

//         {/* Transaction Status Filter */}
//         <div className="space-y-1">
//           <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center gap-2">
//             <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
//               <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
//             </svg>
//             Status
//           </label>
//           <select
//             name="transactionStatus"
//             value={filters.transactionStatus}
//             onChange={handleFilterChange}
//             className="w-full p-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 shadow-xs"
//           >
//             <option value="all">All Statuses</option>
//             {transactionStatusOptions.map((option) => (
//               <option key={option.value} value={option.value}>
//                 {option.label}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Upload Statement */}
//         <div className="space-y-1">
//           <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center gap-2">
//             <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
//               <path strokeLinecap="round" strokeLinejoin="round" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
//             </svg>
//             Upload Statement
//           </label>
//           <UploadTicketStatement onTransactionsExtracted={handleTicketTransactionsExtracted} />
//         </div>
//       </div>
//     </div>
//   );
// };
// export default RevenueFilters;




const RevenueFilters = ({
  filters,
  setFilters,
  banks,
  theatreAccounts,
  selectedBank,
  setSelectedBank,
  selectedTheatreAccount,
  setSelectedTheatreAccount,
  handleGenerateClick,
  showBankSelector,
  handleGenerateFile,
  handleBankChange,
  handleTicketTransactionsExtracted,
  theatreOptions,
  paymentModeOptions,
  transactionStatusOptions,
  clearFilters
}) => {

  console.log('filters in the Reenuw filters', filters);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  // const clearFilters = () => {
  //   setFilters({
  //     paymentMode: 'all',
  //     transactionStatus: 'all',
  //     dateRange: 'all',
  //     startDate: '',
  //     endDate: ''
  //   });
  // };












  return (
    <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 mb-6">
      <h2 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clipRule="evenodd" />
        </svg>
        Filters
      </h2>
  
      {/* <div className="space-y-4"> */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* First Row: Date Range */}
        {/* <div className="bg-gray-50 p-4 rounded-lg border border-gray-200"> */}
        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 col-span-1">
          <div className="flex justify-between items-center mb-3">
            <h3 className="text-sm font-medium text-gray-700 flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Date Range
            </h3>
            <button
              onClick={clearFilters}
              className="text-xs text-red-600 hover:text-red-800 flex items-center gap-1 transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              Clear Filters
            </button>
          </div>
  
          <div className="space-y-3">
            <select
              name="dateRange"
              value={filters.dateRange}
              onChange={handleFilterChange}
              className="w-full p-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 shadow-xs"
            >
              <option value="all">All Time</option>
              <option value="today">Today</option>
              <option value="yesterday">Yesterday</option>
              <option value="week">Last 7 Days</option>
              <option value="month">Last 30 Days</option>
              <option value="custom">Custom Range</option>
            </select>
  
            {filters.dateRange === 'custom' && (
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs text-gray-500 mb-1">Start Date</label>
                  <input
                    type="date"
                    name="startDate"
                    value={filters.startDate}
                    onChange={handleFilterChange}
                    className="w-full p-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-xs text-gray-500 mb-1">End Date</label>
                  <input
                    type="date"
                    name="endDate"
                    value={filters.endDate}
                    onChange={handleFilterChange}
                    className="w-full p-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
              </div>
            )}
          </div>
  
          {/* Generate Bank File Section */}
          <div className="mt-4 space-y-3">
            {!showBankSelector ? (
              <button
                className="w-full px-4 py-2.5 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors flex items-center justify-center gap-2 shadow-sm"
                onClick={handleGenerateClick}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                Generate Bank File
              </button>
            ) : (
              <div className="flex flex-col gap-3 bg-blue-50 p-3 rounded-lg border border-blue-100">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1 flex items-center gap-1">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
                      </svg>
                      Payout Bank
                    </label>
                    <select
                      value={selectedBank}
                      onChange={handleBankChange}
                      className="w-full p-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="Select Bank">Select Bank</option>
                      {banks.map((bank) => (
                        <option key={bank.id || bank.bankName} value={bank.bankName}>
                          {bank.bankName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1 flex items-center gap-1">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                      </svg>
                      Beneficiary Account
                    </label>
                    <select
                      value={selectedTheatreAccount?._id || ''}
                      onChange={(e) => {
                        const account = theatreAccounts.find(acc => acc._id === e.target.value);
                        setSelectedTheatreAccount(account || null);
                      }}
                      className="w-full p-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="">Select Beneficiary</option>
                      {theatreAccounts.map((account) => (
                        <option key={account._id} value={account._id}>
                          {account.theatreName} ({account.bankName})
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <button
                  className="px-4 py-2.5 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors flex items-center justify-center gap-2 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={handleGenerateFile}
                  disabled={!selectedBank || selectedBank === "Select Bank"}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
                  </svg>
                  Generate File
                </button>
              </div>
            )}
          </div>
        </div>
  
        {/* Second Row: Filters in a single row */}
        {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-4"> */}
        <div className="col-span-1">
          {/* Payment Mode Filter */}
          <div className="space-y-1">
            <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
              </svg>
              Payment Mode
            </label>
            <select
              name="paymentMode"
              value={filters.paymentMode}
              onChange={handleFilterChange}
              className="w-full p-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 shadow-xs"
            >
              <option value="all">All Payment Modes</option>
              {paymentModeOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
  
          {/* Theater Filter */}
          <div className="space-y-1">
            <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
              </svg>
              Theatres
            </label>
            <select
              name="theatreName"
              value={filters.theatreName}
              onChange={handleFilterChange}
              className="w-full p-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 shadow-xs"
            >
              <option value="all">All Theatres</option>
              {theatreOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
  
          {/* Transaction Status Filter */}
          <div className="space-y-1">
            <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Status
            </label>
            <select
              name="transactionStatus"
              value={filters.transactionStatus}
              onChange={handleFilterChange}
              className="w-full p-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 shadow-xs"
            >
              <option value="all">All Statuses</option>
              {transactionStatusOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
  
        {/* Third Row: Upload Statement - Full width */}
        {/* <div className="space-y-1"> */}
        <div className="col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
            </svg>
            Upload Statement
          </label>
          <UploadTicketStatement onTransactionsExtracted={handleTicketTransactionsExtracted} />
        </div>
      </div>
    </div>
  );


};
export default RevenueFilters;
